import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Accordion, Card, Container } from "react-bootstrap";
import logo from "../../assets/white-logo.svg";

let qandA = require("./../../config/qanda.json");

const Help = props => {
  const { logout } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let x = 0;
  let counter = 0;

  return (
    <>
      <div className={`imageContainer hero-container primary`}>
        <div className="d-flex flex-row-reverse logout-container">
          <a className="p-2 logout-link" href="#" onClick={logout}>
            Logout
          </a>
        </div>
        <div className="logoContainer">
          <img src={logo} alt="logo" className="logo" />
        </div>
        <div className="darkgradient" />
      </div>
      <Container className="help">
        <Accordion defaultActiveKey="0">
          {qandA.map(obj => {
            const { type, question, answer } = obj;
            x++;
            return (
              <Card>
                <Accordion.Toggle as={Card.Header} variant="link" eventKey={x}>
                  <b>{(type === "qanda" && "Q") || ++counter}: </b> {question}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={x}>
                  <Card.Body dangerouslySetInnerHTML={{ __html: answer }} />
                </Accordion.Collapse>
              </Card>
            );
          })}
        </Accordion>
      </Container>
    </>
  );
};

export default connect()(Help);
